import styled from "styled-components";

export const MedBoxLog = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
  border: 1px solid var(--dark-light);
  padding: 1em;
  border-radius: 10px;
  position: relative;
  margin-bottom: 1.5em;

  .toNo {
    position: absolute;
    top: -12px;
    padding: 0px 10px;
    left: 50%;
    font-weight: 500;
    transform: translate(-50%);
    background: #fff;
    color: var(--accent);
    border-radius: 0 10px 10px 0;
  }

  .medHeading {
    margin-top: 5px;
    font-size: 16px;
    grid-column: 1/4;
    font-weight: 600;
    display: flex;
    flex-flow: column;

    span {
      font-size: 12px;
    }
  }

  label {
    font-size: medium;
    color: var(--dark);
    font-weight: 500;
    font-size: 12px;
    margin: 0;
  }

  p {
    font-weight: 600;
    font-size: 16px;
    color: var(--accent);
    margin: 0;
  }
`;
